import createReactClass from 'create-react-class';
import Morearty from 'morearty';
import React from 'react';

import { AdminPage } from '../../lib/admin_layout';
import AppFeaturesMixin from 'components/lib/app_features_mixin';
import UserEditorContainer from './user_editor_container';

const UserEditorPage = createReactClass({
  mixins: [AppFeaturesMixin, Morearty.Mixin],

  render() {
    return <AdminPage>{this.renderUserEditor()}</AdminPage>;
  },

  renderUserEditor() {
    if (this.isFeatureEnabled('userManagement')) {
      return <UserEditorContainer />;
    }
    return null;
  },
});

export default UserEditorPage;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/users/user_editor/user_editor_page.jsx